// extracted by mini-css-extract-plugin
export default {"costSectionRow":"CostSection_costSectionRow__YmpuE","statsCol":"CostSection_statsCol__abQ+F","graphCol":"CostSection_graphCol__oZK8f"};